export const COLORS_CHART = [
  "#FF6B6B",
  "#4ECDC4",
  "#45B7D1",
  "#FFA07A",
  "#98D8C8",
  "#F7DC6F",
  "#BB8FCE",
  "#85C1E2",
  "#F06292",
  "#AED581",
];

export const STATUS_COLORS: { [key: string]: string } = {
  DONE: "#4CAF50",
  IN_PROGRESS: "#2196F3",
  TODO: "#FFC107",
  BACKLOG: "#9E9E9E",
  TEST: "#9C27B0",
  BLOCKED: "#F44336",
  DEV_DONE: "#00BCD4",
  R2: "#FF9800",
};

export const SEVERITY_COLORS: { [key: string]: string } = {
  Highest: "#D32F2F",
  High: "#F57C00",
  Medium: "#FBC02D",
  Low: "#7CB342",
  NOT_SET: "#9E9E9E",
  Unknown: "#9E9E9E",
};

export const secondsToHours = (seconds: number): number => {
  return Math.round((seconds / 3600) * 10) / 10;
};

export function formatCodeLabel(raw?: string | null): string {
  if (!raw) return "";

  // Normalize: trim and collapse spaces
  const normalized = raw.trim().replace(/\s+/g, " ");

  // If contains space already, just title-case words
  if (normalized.includes(" ")) {
    return normalized
      .toLowerCase()
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  }

  // Handle snake / upper-snake / kebab and plain uppercase
  return normalized
    .toLowerCase()
    .replace(/[-_]+/g, " ")
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
